import { ImageLoading } from "../../../../components/ImageLoading/ImageLoading";
import { isEmpty, map } from "lodash";
import React from "react";
import styles from "./Index.module.scss";
import { IndexBloc } from "./IndexBloc";
import { useDidMount } from "../../../../hooks/useDidMount";
export function MapImg(props) {
  var bloc = new IndexBloc();
  useDidMount(function () {
    if (isEmpty(props.placeId)) {
      return;
    }
    bloc.initImg(props.placeId);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles.MapImgLIst
  }, map(bloc.photoList.value, function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: item + index,
      className: styles.ImgItem
    }, /*#__PURE__*/React.createElement(ImageLoading, {
      loading: item === "pending",
      showLabel: false,
      style: {
        width: "80px",
        height: "80px"
      }
    }), item !== "pending" && /*#__PURE__*/React.createElement("img", {
      src: item,
      alt: ""
    }));
  }));
}